import React, { useEffect, useState } from "react"
import styles from "./Thanks.module.css"
import { getAreaPrefecture } from "./getAreaPrefecture"
import { ThanksProps } from "./types"

const Thanks = ({ formState }: ThanksProps) => {
    const [area, setArea] = useState("")
    const [genre, setGenre] = useState(null)
    const [occupation, setOccupation] = useState(null)
    useEffect(() => {
        const getArea = getAreaPrefecture(formState.prefecture)
        const userResumes = formState.userResumesAttributes[0]
        setGenre(userResumes.genreId)
        setOccupation(userResumes.occupationIds)
        setArea(getArea)
    }, [formState])
    return (
        <div className={styles.background}>
            <div className={styles.sparklingLeft}>
                <img
                    src="/foodslaboEf/img/ProgressBanner/decoration-left.png"
                    alt="decoration-left"
                />
            </div>
            <div className={styles.sparklingRight}>
                <img
                    src="/foodslaboEf/img/ProgressBanner/decoration-right.png"
                    alt="decoration-left"
                />
            </div>
            <div className={styles.thanks}>
                <div>
                    <p className={styles.thanksText}>
                        \ ご登録ありがとうございます！ /
                    </p>
                    <div>
                        <img
                            src={`/client/img/thanks/foodslabo/tel-${area}-sp.png`}
                            alt={"各拠点電話番号"}
                        />
                    </div>
                </div>
                <div>
                    <a href="/mypage/resumes/new">
                        <img
                            src="/foodslaboEf/img/Thanks/merit-banner.png"
                            alt="メリット画像"
                            className={styles.merit}
                        />
                    </a>
                </div>
                <div>
                    <img
                        src="/foodslaboEf/img/Thanks/explanation.png"
                        alt="活用法画像"
                        className={styles.explanation}
                    />
                </div>
                <div className={styles.ctaButtonWrap}>
                    <button className={styles.ctaButton}>
                        <a
                            href={`/offers/search/genres-${genre}/occupations-${occupation}`}
                        >
                            求人を探して、さらに応募
                            <span>
                                <img
                                    src={"/foodslaboEf/img/Thanks/arrow.svg"}
                                    alt={"arrow"}
                                />
                            </span>
                        </a>
                    </button>
                </div>
            </div>
        </div>
    )
}

export default Thanks
